module.exports = ".footer{\r\n    background: #000;\r\n    color:#fff;\r\n    text-align:center;\r\n    font-size:12px;\r\n    padding:30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.css
// module id = ./src/app/common/footer/footer.component.css
// module chunks = main